import React from "react";
import './Buytoken.scss';
function UwpsTokens() {
  const steps = [
    {
      id: 1,
      title: "Sign up & Complete KYC on UniWallet Pay",
      className: "Step1",
    },
    { id: 2, title: "Deposit Funds (Fiat/crypto)", className: "Step2" },
    { id: 3, title: "Go to ICO section", className: "Step3" },
    {
      id: 4,
      title: "Enter the desired amount of UWPS tokens",
      className: "Step4",
    },
    { id: 5, title: "Review and confirm the purchase", className: "Step5" },
  ];
  const steps2 = [
    {
      id: 1,
      title:
        "Link your crypto wallet (using WalletConnect) with UniWallet Pay’s ICO",
      className: "Step1",
    },
    {
      id: 2,
      title: "Specify the required number of tokens",
      className: "Step2",
    },
    { id: 3, title: "Confirm the transaction details", className: "Step3" },
    {
      id: 4,
      title: "Pay the related gas fee",
      className: "Step4",
    },
  ];
  return (
    <div className="uwpsTokens">
      <div className="container">
        <h2 className="headingText">How to Buy UWPS Tokens?</h2>
        <p className="commonText">UniWallet Pay offers two convenient ways to purchase UWT tokens.</p>
        <div className="uwpsTokens_cards">
          <div className="tokenscard">
            <h3>Direct Purchase through Centralized Platform</h3>
            <div className="tokenscard_section">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className={`${step.className} tokenscard_innerCard`}
                >
                  <p>Step {step.id}</p>
                  <div className="hr-line"></div>
                  <h4>{step.title}</h4>
                </div>
              ))}
            </div>
            <p className="tokenscard_bottomText">
              UWPS tokens will be automatically credited to your UniWallet Pay
              account. Once the token sale concludes, you can choose to hold your
              tokens, trade them on supported exchanges, or transfer them to an
              external wallet.
            </p>
          </div>
          <div className="tokenscard">
            <h3>Buy on Decentralized Platform</h3>
            <div className="tokenscard_section">
              {steps2.map((step2) => (
                <div
                  key={step2.id}
                  className={`${step2.className} tokenscard_innerCard`}
                >
                  <p>Step {step2.id}</p>
                  <div className="hr-line"></div>
                  <h4>{step2.title}</h4>
                </div>
              ))}
            </div>
            <p className="tokenscard_bottomText">
              After the transaction is confirmed on the blockchain, you will
              receive UWPS tokens in your connected wallet.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UwpsTokens;
